<template>
  <s-button
    @click="clickFunction()"
    element-name="homebutton"
    :dark="true"
    :flat="true"
    class="underline"
    >{{ text || $t('components.menuOptions.home') }}</s-button
  >
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    text: {
      type: String
    }
  },
  methods: {
    clickFunction() {
      if (this.$from.name === 'start') {
        this.$router.back();
      } else {
        this.$router.push({ name: 'start' });
      }
    }
  },
  computed: {
    ...mapState({
      $from: state => state.route.from
    })
  }
};
</script>

<style></style>
